import TableRowOrigin from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableRowOrigin";
import TableRowDestination from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableRowDestination";

export const splicingObjectItemsListMixin = {
  props: {
    object: Object,

    oppositeObjects: Array,

    objects: Array,

    selectedItem: Object,

    side: String,

    connections: Array,

    updateCounter: Number,

    disabled: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    oppositeSide() {
      if (this.side === "origin") {
        return "destination";
      } else {
        return "origin";
      }
    },

    rowComponent() {
      if (this.side === "origin") {
        return TableRowOrigin;
      } else {
        return TableRowDestination;
      }
    }
  },

  methods: {
    getConnectionPointState(fiberOrPort, prefix) {
      if (this.connections) {
        let connection = this.connections.find(
          item => item[this.side].uuid === fiberOrPort[prefix + "_uuid"]
        );
        if (connection && connection[this.oppositeSide].id) {
          if (
            this.isConnectedToOppositeSide(connection) ||
            this.isConnectedToSameSide(connection)
          ) {
            if (connection.same_side_connection) {
              return this.side === "origin" ? "connected" : "in";
            } else {
              return "connected";
            }
          } else if (connection[this.oppositeSide].type === "port") {
            return "split";
          }
          return "occupied";
        }else if(connection && !connection[this.oppositeSide].id){
          return "free";
        } else {
          connection = this.connections.find(
            item =>
              item[this.oppositeSide].uuid === fiberOrPort[prefix + "_uuid"]
          );
          if (connection) {
            if (this.isConnectedToSameSide(connection)) {
              return this.side === "destination" ? "connected" : "in";
            } else {
              return "occupied";
            }
          }
        }
      }
      return "free";
    },

    isConnectedToOppositeSide(connection) {
      let connectedItem = connection[this.oppositeSide];

      if (connectedItem.type === "fiber" && this.oppositeObjects.length > 0) {
        return this.isConnectedToCableOnOppositeSide(connectedItem);
      } else if (
        connectedItem.type === "port" &&
        this.oppositeObjects.length > 0
      ) {
        return this.isConnectedToSplitterOnOppositeSide(connectedItem);
      }
      return false;
    },

    isConnectedToSameSide(connection) {
      let side = this.side === "origin" ? this.oppositeSide : this.side;
      let connectedItem = connection[side];
      if (connectedItem.type === "fiber") {
        return this.isConnectedToCableOnSameSide(connectedItem);
      }
      return false;
    },

    isConnectedToCableOnOppositeSide(connectedItem) {
      let cables = this.getOppositeSideCables();
      for (const cable of cables) {
        let oppositeItem = cable.fibers.find(
          fiber => fiber.fb_uuid === connectedItem.uuid
        );
        if (oppositeItem) {
          return true;
        }
      }
      return false;
    },

    isConnectedToCableOnSameSide(connectedItem) {
      let cables = this.getSameSideCables();
      for (const cable of cables) {
        let oppositeItem = cable.fibers.find(
          fiber => fiber.fb_uuid === connectedItem.uuid
        );
        if (oppositeItem) {
          return true;
        }
      }
      return false;
    },

    isConnectedToSplitterOnOppositeSide(connectedItem) {
      let splitters = this.getOppositeSideSplitters();
      for (const splitter of splitters) {
        let portType = "inPorts";
        if (this.oppositeSide === "origin") {
          portType = "outPorts";
        }
        let oppositeItem = splitter[portType].find(
          port => port.pt_uuid === connectedItem.uuid
        );
        if (oppositeItem) {
          return true;
        }
      }
      return false;
    },

    getOppositeSideCables() {
      return this.oppositeObjects.filter(object => this.isCable(object));
    },

    getSameSideCables() {
      return this.objects.filter(object => this.isCable(object));
    },

    getOppositeSideSplitters() {
      return this.oppositeObjects.filter(object => this.isSplitter(object));
    },

    isCable(object) {
      return object && object.hasOwnProperty("cb_id");
    },

    isSplitter(object) {
      return object && object.hasOwnProperty("sp_uuid");
    },

    selectItem(item) {
      this.$emit("select-item", item);
    },

    openConnectionPointMenu(e, connectionPoint, prefix) {
      let connectionPoints = [connectionPoint];
      let state = this.getConnectionPointState(connectionPoint, prefix);
      this.openMenu({ event: e, connectionPoints, state, prefix });
    },

    openMenu(itemData) {
      this.$emit("open-menu", itemData);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/splicingObjectItemsListMixin.js